/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import { ModalGeneric } from 'ypf-pas-general-ui-components';

import DuplicatedRequestTable from './DuplicatedRequestTable/DuplicatedRequestTable';

const DuplicatedRequestModal = (props) => {
  const { showModal, setShowModal, data, handlePrimary } = props;

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={() => closeModal()}
      primaryAction={() => {
        closeModal();
        handlePrimary();
      }}
      primaryActionLabel="Crear solicitud duplicada"
      secondaryAction={() => closeModal()}
      secondaryActionLabel="Salir"
      show={showModal}
      size="xl"
      title="Solicitudes de servicio relacionadas"
    >
      <DuplicatedRequestTable data={data} />
    </ModalGeneric>
  );
};

DuplicatedRequestModal.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  data: PropTypes.arrayOf(PropTypes.objectOf({})),
  handlePrimary: PropTypes.func
};
DuplicatedRequestModal.defaultProps = {
  showModal: false,
  setShowModal: () => {
    /* empty */
  },
  data: [],
  handlePrimary: () => {
    /* empty */
  }
};

export default DuplicatedRequestModal;
